<script setup>
const route = useRoute();
const slug = route.params.slug;
const config = useRuntimeConfig();
const baseURL = config.public.baseUrl;
const { data, error } = await useFetch(
  `${baseURL}/content/services/frameworks/${slug}-content.json`
);

if (error.value || !data.value) {
  throw createError({
    statusCode: 404,
    statusMessage: "Page not found",
  });
}

useHead({
  title: data?.value?.meta_tags.title || "",
  meta: data?.value?.meta_tags.meta || [],
   link: [
    { rel: "preload", as: "image", href: data?.value?.header.image }
  ]
});

const visible = ref(false);

const openModal = () => {
  visible.value = true;
};
</script>

<template>
  <!-- Hero Banner -->
  <WrHeroBanner :data="data.header" @open-modal="openModal" />

  <section class="dark:bg-none section-spacing relative z-10">
    <div class="container-wrapper-xl">
      <FloatingList
        :heading="data?.google_autocomplete?.heading"
        :subheading="data?.google_autocomplete?.subheading"
        :expertisetext="data?.expertise?.expertisetext"
        :textcontent="data?.expertise?.textcontent"
        :text="data?.google_autocomplete?.text"
        :keywords=" data?.google_autocomplete?.keywords ?? data?.google_autocomplete?.google_autocomplete?.keywords"
      />
      <WrGoogleRating />
    </div>
  </section>

  <section class="dark:bg-none section-spacing bg-[#5F4CA4]">
    <div class="container-wrapper-xl">
      <WrContactUsCarouselSection :data="data?.contact_us_carousel" />
    </div>
  </section>

  <section class="dark:bg-none section-spacing relative z-10">
    <div class="container-wrapper-lg">
      <WrExpertiseSection :expertise="data?.expertise" />
    </div>
  </section>

  <section class="dark:bg-none section-spacing relative z-10">
    <div class="container-wrapper-xl">
      <WrWhoAreWeCard
        :heading="data?.service_content?.heading"
        :subheading="data?.service_content?.subheading"
        :content="data?.service_content?.text"
      />
    </div>
  </section>

  <section class="dark:bg-none section-spacing relative z-10">
    <div class="container-wrapper-xl">
      <WrImageContent
        :whyChooseUs="data?.why_choose_us"
        :header="'Let\'s Start Together'"
        :src="'/images/why-chose-us.webp'"
        height="360"
        width="466"
        @openModal="openModal"
      />
    </div>
  </section>

  <section class="dark:bg-none section-spacing relative z-10">
    <div class="container-wrapper-xl">
      <WrOurPromiseSection :data="data?.our_promises" />
    </div>
  </section>

  <WrOurServiceSection title="Our Services" description="" />

  <section
    class="relative z-10 dark:bg-none section-spacing overflow-visible order-9"
  >
    <div class="container-wrapper-lg w-full relative">
     <div class="hidden  dark:block opacity-30  md:size-[764px] rounded-full 
         bg-[linear-gradient(136.28deg,_rgba(51,4,79,0)_30.43%,_#260049_54.53%,_#36006F_92.37%)] 
         absolute -top-[30%] -left-[67%]">
      </div>

      <div class="hidden  dark:block opacity-50 size-[190px] rounded-full 
         bg-[image:var(--bg-circle-top-light)] 
         absolute -bottom-[15%] right-0 top-0">
      </div>
      <WrSelectedProject />
    </div>
  </section>

  <section class="relative overflow-hidden dark:bg-none section-spacing z-20">
    <div class="container-wrapper-xl">
      <h2 class="text-center mb-11">
        <WrGradientText
          text="Trusted for excellence and efficiency"
          append-class="text-3xl lg:text-[48px]"
        />
        <p class="text-lg text-[var(--foreground)] font-anvtgrade-book">
          Webreinvent is trusted by leading organisations to enhance their
          development and operational efficiency.
        </p>
      </h2>
      <!-- Carousel Section -->
      <WrTestimonialCardCarousel />
      <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7"
        >View All</WrButton
      >
    </div>
  </section>
  <WrContactFormPopup :isOpen="visible" @close="visible = false" class="z-30" />
</template>
